//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from 'vuex';
import product from '~/graphql/queries/product.gql';
import randomProducts from '~/graphql/queries/randomProducts.gql';

export default {
  apollo: {
    product: {
      query: product,
      variables() {
        return {
          slug: this.$route.params.slug,
        };
      },
      result({data: {product}}) {
        if (!product) {
          this.$nuxt.error({statusCode: 404, message: 'Product not found'});
        }

        if (product.type_waarde === 'Vast') {
          this.form.value = product.waarde;
        } else {
          this.form.value = parseFloat(product.waarde_min).toFixed(2);
        }
      },
    },
    randomProducts: {
      query: randomProducts,
      variables: {
        limit: 3,
      },
      result({data}) {
        if (data.randomProducts) {
          this.randomProducts = this.mapRandomProducts(data.randomProducts);
        }
      },
      skip() {
        return this.whiteLabelEnabled;
      },
    },
  },
  data: () => ({
    relatedProducten: [],
    cartObject: {},
    product: {},
    randomProducts: [],
    form: {
      value: 0,
      quantity: 1,
      shippingMethod: 'email',
      businessOrder: false,
    },
    openModal: false,
    maxQuantity: 100,
    priceInterval: 0,
  }),
  nuxtI18n: {
    paths: {
      nl: '/assortiment/:slug',
      en: '/assortment/:slug',
    },
  },
  head() {
    return {
      title: this.selectedProduct?.title ?? '',
    };
  },
  computed: {
    ...mapGetters({
      whiteLabelEnabled: 'whitelabel/isEnabled',
    }),
    selectedProduct() {
      if (this.form.shippingMethod === 'email') {
        return {...this.product, ...this.product.digital_sibling};
      }

      return this.product;
    },
    shippingOptions() {
      const options = [];
      if (this.product.fysiek) {
        options.push({id: 2, value: 'post', label: this.$t('By post')});
      }

      if (!this.product.fysiek || this.product.digital_sibling) {
        options.push({id: 1, value: 'email', label: this.$t('By email')});
      }

      return options;
    },
    price() {
      return this.isVast ? this.product.waarde : this.product.waarde_max;
    },
    isVast() {
      return this.selectedProduct.type_waarde === 'Vast';
    },
    quantityRange() {
      return Array.from({length: this.maxQuantity}, (v, k) => k + 1);
    },
    priceOptions() {
      if (this.selectedProduct.tegoed_opties) {
        return this.selectedProduct.tegoed_opties.split(',');
      } else {
        return [];
      }
    },
    productHasImage() {
      return this.product.active_image?.url;
    },
  },
  created() {
    if (this.$store.state.whitelabel) {
      this.form.shippingMethod = this.$store.state.whitelabel.default_shipping_method ?? 'email';
    }
  },
  methods: {
    addToCart() {
      if (this.form.businessOrder) {
        this.$store.commit('cart/setOrderAs', 'business');
      }

      this.cartObject = {
        product: this.selectedProduct,
        quantity: +this.form.quantity,
        amount: this.form.value,
      };
      this.$store.commit('cart/add', this.cartObject);

      return (this.openModal = true);
    },
    mapRandomProducts(products) {
      return products.map((product) => {
        return {
          id: product.id,
          slug: product.slug,
          title: product.title,
          fysiek: product.fysiek,
          own_design: product.own_design,
          content:
            product.type_waarde === 'Min/Max'
              ? this.$options.filters.money(product.waarde_min) +
                ' - ' +
                this.$options.filters.money(product.waarde_max)
              : this.$options.filters.money(product.waarde),
          img: {
            source: product.active_image ? product.active_image.url : '',
          },
          styleObject: {
            backgroundColor: product.color_code || '#fff',
          },
        };
      });
    },
  },
};
